import { i18n } from '@lingui/core';
import { t } from '@lingui/core/macro';
import { Box, Chip, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { dashboardTemplates, useInsightsTemplates } from './Context';
import { Visualization } from '../Visualization';
import { WidgetBody, WidgetContainer, WidgetHeader } from '../Widget/styled';
import { WidgetGridLayout } from '../WidgetGrid/WidgetGridLayout';
export function TemplatePreview() {
    const { selected } = useInsightsTemplates();
    const template = dashboardTemplates.find((mock) => mock.id === selected);
    const { slots } = template || {};
    if (!slots) {
        return null;
    }
    const layouts = {
        lg: slots.map((slot) => ({
            i: slot.id,
            x: slot.x,
            y: slot.y,
            w: slot.w,
            h: slot.h,
            widgetId: slot.widgetId,
            static: true,
        })),
    };
    return (<WidgetGridLayout layouts={layouts}>
      {slots.map((slot) => (<WidgetContainer $editMode={false} key={slot.id}>
          <WidgetHeader width="100%" p="2xl" pb="0" alignItems="center" gap="md">
            <Typography $fontWeight="bold" $fontSize="large" $appearance="300" $lineHeight="neutralized" $truncate>
              {i18n._(slot.widget.label)}
            </Typography>
            <Box ml="auto" alignItems="center" gap="md">
              {slot.widget.filters && (<Chip label={t({
                    message: 'Filtered',
                    comment: 'Indicator on widget if data is filtered',
                    context: 'insights',
                })} icon={<Falcon icon="bars-filter"/>}/>)}
            </Box>
          </WidgetHeader>

          <WidgetBody alignItems="center" justifyContent="center" p="2xl" pt="0">
            <Visualization type={slot.widget.type} aggregations={slot.widget.aggregations} filters={slot.widget.filters} colorScheme={slot.widget.colorScheme} isHorizontal={slot.widget.isHorizontal}/>
          </WidgetBody>
        </WidgetContainer>))}
    </WidgetGridLayout>);
}
